(function () {

  function initFurRelatedProducts(section) {

    if (!section) {
      return;
    }


    if (
      section.dataset.furRelatedInitialized ===
      'true'
    ) {
      return;
    }


    section.dataset.furRelatedInitialized =
      'true';


    let track =
      section.querySelector(
        '[data-fur-related-track]'
      );


    if (!track) {
      return;
    }


    /* =====================================================
       LOAD SHOPIFY RECOMMENDATIONS
    ===================================================== */

    async function loadRecommendations() {

      /*
       * If Shopify already rendered recommendations,
       * don't request again.
       */

      if (
        track.querySelector(
          '[data-fur-related-item]'
        )
      ) {

        initInteractions();

        return;

      }


      const productId =
        section.dataset.productId;


      const sectionId =
        section.dataset.sectionId;


      const limit =
        section.dataset.productsLimit ||
        '8';


      if (
        !productId ||
        !sectionId
      ) {

        console.warn(
          'THE FUR: Related product data missing.'
        );

        return;

      }


      section.classList.add(
        'is-loading'
      );


      try {

        const root =
          window.Shopify?.routes?.root ||
          '/';


        const url =
          root +
          'recommendations/products' +
          '?section_id=' +
          encodeURIComponent(sectionId) +
          '&product_id=' +
          encodeURIComponent(productId) +
          '&limit=' +
          encodeURIComponent(limit);


        const response =
          await fetch(url);


        if (!response.ok) {

          throw new Error(
            'Unable to load recommendations.'
          );

        }


        const html =
          await response.text();


        const parser =
          new DOMParser();


        const documentFragment =
          parser.parseFromString(
            html,
            'text/html'
          );


        const loadedSection =
          documentFragment.querySelector(
            '[data-fur-related-products]'
          );


        if (!loadedSection) {

          section.classList.add(
            'is-empty'
          );

          return;

        }


        const loadedTrack =
          loadedSection.querySelector(
            '[data-fur-related-track]'
          );


        if (
          !loadedTrack ||
          !loadedTrack.querySelector(
            '[data-fur-related-item]'
          )
        ) {

          section.classList.add(
            'is-empty'
          );

          return;

        }


        /*
         * Replace only the products.
         */

        track.innerHTML =
          loadedTrack.innerHTML;


        section.classList.remove(
          'is-loading',
          'is-empty'
        );


        /* =================================================
           GLOBAL LINK HOVER SYSTEM
        ================================================== */

        if (
          window.FurStretchLinks &&
          typeof window
            .FurStretchLinks
            .init === 'function'
        ) {

          window.FurStretchLinks.init(
            track
          );

        }


        /*
         * Now initialize all related-product interactions,
         * including the Editorial image slider.
         */

        initInteractions();


      } catch (error) {

        console.error(
          'THE FUR RELATED PRODUCTS:',
          error
        );


        section.classList.remove(
          'is-loading'
        );

      }

    }


    /* =====================================================
       INTERACTIONS
    ===================================================== */

    function initInteractions() {

      /*
       * Prevent duplicate setup.
       */

      if (
        track.dataset.furRelatedInteractions ===
        'true'
      ) {
        return;
      }


      track.dataset.furRelatedInteractions =
        'true';


      /* ===================================================
         ELEMENTS
      =================================================== */

      const previousButton =
        section.querySelector(
          '[data-fur-related-previous]'
        );


      const nextButton =
        section.querySelector(
          '[data-fur-related-next]'
        );


      const cursor =
        section.querySelector(
          '[data-fur-related-cursor]'
        );


      const productCards =
        Array.from(
          track.querySelectorAll(
            '[data-editorial-product-card]'
          )
        );


      const dragEnabled =
        track.getAttribute(
          'data-drag-enabled'
        ) !== 'false';


      /* ===================================================
         DRAG STATE
      =================================================== */

      let pointerDown =
        false;


      let isDragging =
        false;


      let blockNextClick =
        false;


      let startX =
        0;


      let startY =
        0;


      let startScrollLeft =
        0;


      const DRAG_THRESHOLD =
        7;


      /* =====================================================
         EXACT EDITORIAL PRODUCT IMAGE SLIDER

         Image 1
              ↓
         slides left

         Image 2
              ↓
         enters from right

              ↓ immediately

         Image 2 slides left

         Image 3
              ↓
         enters and STOPS

         Mouse leave
              ↓
         Reset to Image 1
      ===================================================== */

      function initEditorialCardSlider(card) {

        if (!card) {
          return;
        }


        if (
          card.dataset
            .editorialCardSliderInitialized ===
          'true'
        ) {
          return;
        }


        const media =
          card.querySelector(
            '[data-editorial-card-media]'
          );


        if (!media) {
          return;
        }


        const images =
          Array.from(
            media.querySelectorAll(
              '[data-editorial-card-image]'
            )
          ).slice(0, 3);


        if (!images.length) {
          return;
        }


        card.dataset
          .editorialCardSliderInitialized =
          'true';


        /*
         * Exact duration from Editorial Featured.
         */

        const transitionDuration =
          420;


        let currentIndex =
          0;


        let hovering =
          false;


        let transitioning =
          false;


        let sliderTimer =
          null;


        /* =================================================
           CLEAR TIMER
        ================================================== */

        function clearSliderTimer() {

          if (
            sliderTimer !== null
          ) {

            window.clearTimeout(
              sliderTimer
            );


            sliderTimer =
              null;

          }

        }


        /* =================================================
           CLEAR IMAGE
        ================================================== */

        function clearImage(image) {

          if (!image) {
            return;
          }


          image.classList.remove(
            'is-active',
            'is-current',
            'is-next'
          );


          image.style.removeProperty(
            'transition'
          );


          image.style.removeProperty(
            'transform'
          );


          image.style.removeProperty(
            'opacity'
          );


          image.style.removeProperty(
            'visibility'
          );


          image.style.removeProperty(
            'z-index'
          );

        }


        /* =================================================
           RESET TO IMAGE 1
        ================================================== */

        function resetCardImages() {

          clearSliderTimer();


          currentIndex =
            0;


          transitioning =
            false;


          images.forEach(
            function (image) {

              clearImage(
                image
              );

            }
          );


          images[0].classList.add(
            'is-active'
          );

        }


        /* =================================================
           FINISH ONE SLIDE
        ================================================== */

        function finishSlide(
          currentImage,
          nextImage,
          nextIndex
        ) {

          clearImage(
            currentImage
          );


          clearImage(
            nextImage
          );


          nextImage.classList.add(
            'is-active'
          );


          currentIndex =
            nextIndex;


          transitioning =
            false;


          /*
           * Mouse already left:
           * immediately restore Image 1.
           */

          if (!hovering) {

            resetCardImages();

            return;

          }


          /*
           * Continue automatically.
           *
           * 1 -> 2
           * 2 -> 3
           *
           * No pause on Image 2.
           */

          if (
            currentIndex <
            images.length - 1
          ) {

            window.requestAnimationFrame(
              function () {

                if (
                  hovering &&
                  !isDragging &&
                  !pointerDown
                ) {

                  slideToNext();

                }

              }
            );

          }

        }


        /* =================================================
           RUN ONE SLIDE
        ================================================== */

        function runSlide(
          currentImage,
          nextImage,
          nextIndex
        ) {

          if (
            transitioning ||
            !hovering ||
            isDragging ||
            pointerDown
          ) {
            return;
          }


          transitioning =
            true;


          /* =============================================
             CURRENT IMAGE
          ============================================== */

          clearImage(
            currentImage
          );


          currentImage.classList.add(
            'is-current'
          );


          currentImage.style.zIndex =
            '3';


          currentImage.style.opacity =
            '1';


          currentImage.style.visibility =
            'visible';


          currentImage.style.transition =
            'none';


          currentImage.style.transform =
            'translate3d(0, 0, 0)';


          /* =============================================
             NEXT IMAGE
          ============================================== */

          clearImage(
            nextImage
          );


          nextImage.classList.add(
            'is-next'
          );


          nextImage.style.zIndex =
            '4';


          nextImage.style.opacity =
            '1';


          nextImage.style.visibility =
            'visible';


          nextImage.style.transition =
            'none';


          nextImage.style.transform =
            'translate3d(100%, 0, 0)';


          /*
           * Force browser to register
           * starting position.
           */

          media.offsetWidth;


          /* =============================================
             EXACT EDITORIAL TRANSITION
          ============================================== */

          const transition =
            'transform ' +
            transitionDuration +
            'ms cubic-bezier(0.76, 0, 0.24, 1)';


          currentImage.style.transition =
            transition;


          nextImage.style.transition =
            transition;


          /* =============================================
             START
          ============================================== */

          window.requestAnimationFrame(
            function () {

              window.requestAnimationFrame(
                function () {

                  if (
                    !hovering ||
                    isDragging ||
                    pointerDown
                  ) {
                    return;
                  }


                  currentImage.style.transform =
                    'translate3d(-100%, 0, 0)';


                  nextImage.style.transform =
                    'translate3d(0, 0, 0)';

                }
              );

            }
          );


          /* =============================================
             FINISH
          ============================================== */

          sliderTimer =
            window.setTimeout(
              function () {

                sliderTimer =
                  null;


                finishSlide(
                  currentImage,
                  nextImage,
                  nextIndex
                );

              },
              transitionDuration + 30
            );

        }


        /* =================================================
           NEXT
        ================================================== */

        function slideToNext() {

          if (
            transitioning ||
            !hovering ||
            isDragging ||
            pointerDown
          ) {
            return;
          }


          /*
           * We reached final image.
           * Stop there.
           */

          if (
            currentIndex >=
            images.length - 1
          ) {
            return;
          }


          const nextIndex =
            currentIndex + 1;


          const currentImage =
            images[currentIndex];


          const nextImage =
            images[nextIndex];


          runSlide(
            currentImage,
            nextImage,
            nextIndex
          );

        }


        /* =================================================
           HOVER ENTER
        ================================================== */

        card.addEventListener(
          'mouseenter',
          function () {

            /*
             * Same Editorial Featured behavior:
             * disabled on mobile.
             */

            if (
              window.innerWidth <= 749
            ) {
              return;
            }


            if (
              isDragging ||
              pointerDown
            ) {
              return;
            }


            hovering =
              true;


            resetCardImages();


            /*
             * resetCardImages does not change
             * hovering, but explicitly retain it.
             */

            hovering =
              true;


            slideToNext();

          }
        );


        /* =================================================
           HOVER LEAVE
        ================================================== */

        card.addEventListener(
          'mouseleave',
          function () {

            hovering =
              false;


            resetCardImages();

          }
        );


        /* =================================================
           MOBILE / RESIZE
        ================================================== */

        window.addEventListener(
          'resize',
          function () {

            if (
              window.innerWidth <= 749
            ) {

              hovering =
                false;


              resetCardImages();

            }

          },
          {
            passive: true
          }
        );


        /* =================================================
           INITIAL
        ================================================== */

        resetCardImages();

      }


      /* =====================================================
         ACTIVATE IMAGE SLIDER ON EVERY RELATED CARD
      ===================================================== */

      productCards.forEach(
        function (card) {

          initEditorialCardSlider(
            card
          );

        }
      );


      /* ===================================================
         CARD DISTANCE
      =================================================== */

      function getCardDistance() {

        const item =
          track.querySelector(
            '[data-fur-related-item]'
          );


        if (!item) {

          return (
            track.clientWidth *
            0.8
          );

        }


        const styles =
          window.getComputedStyle(
            track
          );


        const gap =
          parseFloat(
            styles.gap ||
            styles.columnGap
          ) || 0;


        return (
          item
            .getBoundingClientRect()
            .width +
          gap
        );

      }


      /* ===================================================
         UPDATE ARROWS
      =================================================== */

      function updateArrows() {

        const max =
          Math.max(
            0,
            track.scrollWidth -
            track.clientWidth
          );


        if (previousButton) {

          previousButton.disabled =
            track.scrollLeft <= 2;

        }


        if (nextButton) {

          nextButton.disabled =
            track.scrollLeft >=
            max - 2;

        }

      }


      /* ===================================================
         PREVIOUS
      =================================================== */

      if (previousButton) {

        previousButton.addEventListener(
          'click',
          function (event) {

            event.preventDefault();


            track.scrollBy({
              left:
                -getCardDistance(),

              behavior:
                'smooth'
            });

          }
        );

      }


      /* ===================================================
         NEXT
      =================================================== */

      if (nextButton) {

        nextButton.addEventListener(
          'click',
          function (event) {

            event.preventDefault();


            track.scrollBy({
              left:
                getCardDistance(),

              behavior:
                'smooth'
            });

          }
        );

      }


      track.addEventListener(
        'scroll',
        updateArrows,
        {
          passive: true
        }
      );


      /* ===================================================
         DRAG START
      =================================================== */

      track.addEventListener(
        'pointerdown',
        function (event) {

          if (!dragEnabled) {
            return;
          }


          /*
           * Mobile keeps native swipe.
           */

          if (
            event.pointerType ===
            'touch'
          ) {
            return;
          }


          if (
            event.pointerType ===
              'mouse' &&
            event.button !== 0
          ) {
            return;
          }


          pointerDown =
            true;


          isDragging =
            false;


          blockNextClick =
            false;


          startX =
            event.clientX;


          startY =
            event.clientY;


          startScrollLeft =
            track.scrollLeft;

        }
      );


      /* ===================================================
         DRAG MOVE
      =================================================== */

      track.addEventListener(
        'pointermove',
        function (event) {

          if (
            !dragEnabled ||
            !pointerDown
          ) {
            return;
          }


          const movementX =
            event.clientX -
            startX;


          const movementY =
            event.clientY -
            startY;


          if (!isDragging) {

            if (
              Math.abs(movementX) <
                DRAG_THRESHOLD &&
              Math.abs(movementY) <
                DRAG_THRESHOLD
            ) {

              return;

            }


            /*
             * Vertical movement = normal
             * page scrolling.
             */

            if (
              Math.abs(movementY) >
              Math.abs(movementX)
            ) {

              pointerDown =
                false;


              return;

            }


            isDragging =
              true;


            blockNextClick =
              true;


            track.classList.add(
              'is-dragging'
            );


            /*
             * Hide cursor while dragging.
             */

            if (cursor) {

              cursor.classList.remove(
                'is-visible'
              );

            }


            /*
             * IMPORTANT:
             * reset all card image animations
             * while dragging, exactly like
             * Editorial Featured.
             */

            productCards.forEach(
              function (card) {

                card.dispatchEvent(
                  new Event(
                    'mouseleave'
                  )
                );

              }
            );


            if (
              track.setPointerCapture
            ) {

              try {

                track.setPointerCapture(
                  event.pointerId
                );

              } catch (error) {

                // Ignore.

              }

            }

          }


          /* =================================================
             ACTIVE DRAG
          ================================================= */

          if (isDragging) {

            event.preventDefault();


            track.scrollLeft =
              startScrollLeft -
              movementX;

          }

        }
      );


      /* ===================================================
         STOP DRAG
      =================================================== */

      function stopDragging(event) {

        if (
          !pointerDown &&
          !isDragging
        ) {
          return;
        }


        pointerDown =
          false;


        if (isDragging) {

          track.classList.remove(
            'is-dragging'
          );

        }


        if (
          event &&
          event.pointerId !== undefined &&
          track.hasPointerCapture &&
          track.hasPointerCapture(
            event.pointerId
          )
        ) {

          try {

            track.releasePointerCapture(
              event.pointerId
            );

          } catch (error) {

            // Ignore.

          }

        }


        window.requestAnimationFrame(
          function () {

            updateArrows();

          }
        );

      }


      track.addEventListener(
        'pointerup',
        stopDragging
      );


      track.addEventListener(
        'pointercancel',
        function (event) {

          stopDragging(
            event
          );


          isDragging =
            false;


          blockNextClick =
            false;

        }
      );


      /* ===================================================
         CLICK VS DRAG
      =================================================== */

      track.addEventListener(
        'click',
        function (event) {

          const link =
            event.target.closest(
              '[data-featured-card-link]'
            );


          if (!link) {

            isDragging =
              false;


            blockNextClick =
              false;


            return;

          }


          if (
            blockNextClick ||
            isDragging
          ) {

            event.preventDefault();

            event.stopPropagation();

            event.stopImmediatePropagation();


            isDragging =
              false;


            blockNextClick =
              false;


            return;

          }

        },
        true
      );


      /* ===================================================
         RESET DRAG STATE AFTER POINTER UP
      =================================================== */

      track.addEventListener(
        'pointerup',
        function () {

          window.setTimeout(
            function () {

              isDragging =
                false;


              blockNextClick =
                false;

            },
            50
          );

        }
      );


      /* ===================================================
         PREVENT NATIVE IMAGE DRAG
      =================================================== */

      track.addEventListener(
        'dragstart',
        function (event) {

          const image =
            event.target.closest(
              'img'
            );


          if (image) {

            event.preventDefault();

          }

        }
      );


      /* ===================================================
         CUSTOM CLICK CURSOR
      =================================================== */

      const desktopPointer =
        window.matchMedia(
          '(hover: hover) and (pointer: fine)'
        );


      if (
        cursor &&
        desktopPointer.matches
      ) {

        track.addEventListener(
          'pointermove',
          function (event) {

            const link =
              event.target.closest(
                '[data-featured-card-link]'
              );


            if (
              !link ||
              isDragging ||
              pointerDown
            ) {

              cursor.classList.remove(
                'is-visible'
              );


              return;

            }


            cursor.classList.add(
              'is-visible'
            );


            cursor.style.left =
              event.clientX +
              'px';


            cursor.style.top =
              event.clientY +
              'px';

          }
        );


        track.addEventListener(
          'pointerleave',
          function () {

            cursor.classList.remove(
              'is-visible'
            );

          }
        );


        window.addEventListener(
          'blur',
          function () {

            cursor.classList.remove(
              'is-visible'
            );


            pointerDown =
              false;


            isDragging =
              false;


            blockNextClick =
              false;


            track.classList.remove(
              'is-dragging'
            );

          }
        );

      }


      /* ===================================================
         RESIZE
      =================================================== */

      window.addEventListener(
        'resize',
        updateArrows
      );


      /* ===================================================
         INITIAL ARROW CHECK
      =================================================== */

      window.requestAnimationFrame(
        function () {

          updateArrows();

        }
      );

    }


    /* =====================================================
       START
    ===================================================== */

    loadRecommendations();

  }


  /* =======================================================
     INIT ALL RELATED PRODUCT SECTIONS
  ======================================================= */

  function initAllRelatedProducts(root) {

    const sections =
      root &&
      root.matches?.(
        '[data-fur-related-products]'
      )
        ? [root]
        : Array.from(
            (
              root ||
              document
            ).querySelectorAll(
              '[data-fur-related-products]'
            )
          );


    sections.forEach(
      initFurRelatedProducts
    );

  }


  /* =======================================================
     NORMAL PAGE
  ======================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        initAllRelatedProducts();

      }
    );

  } else {

    initAllRelatedProducts();

  }


  /* =======================================================
     SHOPIFY THEME EDITOR
  ======================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section =
        event.target.matches?.(
          '[data-fur-related-products]'
        )
          ? event.target
          : event.target.querySelector?.(
              '[data-fur-related-products]'
            );


      if (!section) {
        return;
      }


      /*
       * Allow full reinitialization.
       */

      delete section.dataset
        .furRelatedInitialized;


      const relatedTrack =
        section.querySelector(
          '[data-fur-related-track]'
        );


      if (relatedTrack) {

        delete relatedTrack.dataset
          .furRelatedInteractions;


        relatedTrack
          .querySelectorAll(
            '[data-editorial-product-card]'
          )
          .forEach(
            function (card) {

              delete card.dataset
                .editorialCardSliderInitialized;

            }
          );

      }


      initFurRelatedProducts(
        section
      );

    }
  );

})();